/*
 * fn: stripHtml
 *
 * Strips HTML tags into plain text
 *
 */
import { stripExtraSpaces } from './stripExtraSpaces'

const HTML_ENTITIES: Record<string, string> = {
  '&#39;': "'",
  '&amp;': '&',
  '&apos;': "'",
  '&gt;': '>',
  '&hellip;': '…',
  '&ldquo;': '“',
  '&lsquo;': '‘',
  '&lt;': '<',
  '&mdash;': '—',
  '&nbsp;': ' ',
  '&ndash;': '–',
  '&quot;': '"',
  '&rdquo;': '”',
  '&rsquo;': '’',
}

const HTML_ENTITY = new RegExp(Object.keys(HTML_ENTITIES).join('|'), 'g')

export const stripHtml = (input: string = '') =>
  stripExtraSpaces(input.replace(HTML_ENTITY, (entity) => HTML_ENTITIES[entity] ?? entity).replace(/<[^>]*>/g, ''))
